var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 17,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.307 3.849L1.65 12.505v3.246h3.246l8.656-8.656m-3.246-3.246l2.48-2.481a1.082 1.082 0 011.53 0l1.717 1.716a1.082 1.082 0 010 1.53l-2.481 2.48M10.307 3.85l3.246 3.246",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui-edit-e54459cf50766f1c92918e3989ee84c6.svg";
export { SvgIconUiEdit as Component };